import { emails } from '../email'
import { describeTable } from './describeTable'

describeTable(emails, {
  description: `One message synced from a Microsoft 365 mailbox (Microsoft Graph delta sync, see email_accounts), bodies included. Inbox folder rows are direction='inbound', Sent Items rows are direction='outbound' — outbound here means mail a staff member sent from the mailbox itself, NOT system mail (booking confirmations, newsletters, invoices are in notifications and never appear here).
Every inbound row gets exactly one inbox_items row (inbox_items.email_id); join there for classification and handling status. Rows of one thread share conversation_id. internet_message_id is unique; in_reply_to / references carry the RFC threading headers.
received_at is the mail's own timestamp (for outbound rows, the send time). Contains customer personal data and full HTML bodies — aggregate rather than dump body_html.`,
  columns: {
    emailAccountId: 'Mailbox the message was synced from (email_accounts).',
    direction:
      "'inbound' = arrived in the mailbox Inbox; 'outbound' = found in its Sent Items.",
    conversationId:
      'Graph thread id shared by all messages in a conversation; also copied to inbox_items.conversation_id.',
    internetMessageId: 'RFC 5322 Message-ID; unique per message.',
    inReplyTo: 'Message-ID this mail replies to.',
    references: 'JSON array of Message-IDs in the thread chain.',
    fromEmail:
      'Sender address (the customer for inbound, the staff mailbox for outbound).',
    toRecipients:
      'JSON array of {name, email}. ccRecipients has the same shape.',
    bodyPreview:
      'Short plain-text excerpt; use this instead of body_html for summaries.',
    bodyHtml: 'Full HTML body.',
    importance:
      "Sender-set mail importance as reported by Graph: 'low' | 'normal' | 'high'.",
    isRead:
      'Read flag as it was in the mailbox at sync time; not maintained afterwards.',
    receivedAt: 'Message timestamp from the mailbox.',
  },
})
